import { LocalDate } from 'local-date'
import { Customer } from './Customer'
import { Meal } from './Meal'
import { MealDate } from './MealDate'

export class CustomerMeal {

    customermealid? : number
    customer : Customer
    meal : Meal
    customermealBegin : LocalDate
    customermealEnd? : LocalDate
    mealdates? : MealDate[]
    recentMealDate? : MealDate

    constructor(customer : Customer, meal : Meal, customermealBegin : LocalDate, customermealEnd? : LocalDate, mealdates? : MealDate[], recentMealDate? : MealDate, customermealid? : number) {
        this.customer = customer
        this.meal = meal
        this.customermealBegin = customermealBegin
        this.customermealEnd = customermealEnd
        this.mealdates = mealdates
        this.customermealid = customermealid
        this.recentMealDate = recentMealDate
    }

}